"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Qualifiers = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _detailsTabs = require("../common/details-tabs");

var _stripeTable = require("../common/stripe-table");

var _qualifiersList = require("../common/qualifiers-list");

var _jsxRuntime = require("react/jsx-runtime");

var QualifierWrapper = _styledComponents["default"].div.withConfig({
  displayName: "QualifierWrapper",
  componentId: "sc-4re1ny-0"
})(["&&{> *{margin:24px 0;}}"]);

var ThreeColumnTable = (0, _stripeTable.createStripeTable)({
  gridTemplateColumns: '1fr 1fr 1fr'
});
var TwoColumnTable = (0, _stripeTable.createStripeTable)({
  gridTemplateColumns: '1fr 2fr'
});

var Qualifiers = function Qualifiers(_ref) {
  var loanOffer = _ref.loanOffer,
      shownTab = _ref.shownTab,
      handleShownTab = _ref.handleShownTab,
      showExtrapolatedToolTip = _ref.showExtrapolatedToolTip;
  var title = 'Qualification Requirements';

  var _ref2 = loanOffer || {},
      specifics = _ref2.specifics;

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsTabs.MobileTab, {
      shownTab: shownTab,
      handleShownTab: handleShownTab,
      title: title
    }), title === shownTab && /*#__PURE__*/(0, _jsxRuntime.jsxs)(QualifierWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
        bold: true,
        children: "Here's what you need to qualify:"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ThreeColumnTable, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_qualifiersList.QualifiersList, {
          qualifiers: loanOffer.qualifiers,
          showExtrapolatedToolTip: showExtrapolatedToolTip
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
        bold: true,
        children: "Additional Details"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(TwoColumnTable, {
        children: Object.entries(specifics).filter(function (_ref3) {
          var _ref4 = (0, _slicedToArray2["default"])(_ref3, 1),
              key = _ref4[0];

          return specifics[key] !== null;
        }).map(function (_ref5) {
          var _ref6 = (0, _slicedToArray2["default"])(_ref5, 2),
              key = _ref6[0],
              specific = _ref6[1];

          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
              bold: true,
              children: specific.category
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
              children: specific.description
            })]
          }, key);
        })
      })]
    })]
  });
};

exports.Qualifiers = Qualifiers;
//# sourceMappingURL=qualifiers.js.map